import { render, staticRenderFns } from "./ServiceSlider.vue?vue&type=template&id=0f143b32&"
import script from "./ServiceSlider.vue?vue&type=script&lang=js&"
export * from "./ServiceSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports